<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="handleQuery">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
                          <a-form-item label="昵称" prop="nickname">
                            <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
                          </a-form-item>
                     </a-col>
<!--                      <a-col :md="8" :sm="24">-->
<!--                        <a-form-item label="剧集" prop="serialNumber">-->
<!--                          <a-input-number :min="1" v-model="queryParam.serialNumber" style="width: 100%;" placeholder="请输入" allow-clear />-->
<!--                        </a-form-item>-->
<!--                      </a-col>-->
<!--                      <a-col :md="8" :sm="24">-->
<!--                        <a-form-item label="时间" prop="sendTime">-->
<!--                          <a-range-picker v-model="sendTimeAreaData" :locale="locale" @change="onChangeTime">-->
<!--                          </a-range-picker>-->
<!--                        </a-form-item>-->
<!--                      </a-col>-->
          <a-col :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="resetQuery" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operations">
<!--      <a-button type="primary" @click="$refs.noticeCreateForm.handleAdd(circleId)" v-hasPermi="['skoda:circleNotice:add']">-->
<!--        <a-icon type="plus"/>-->
<!--        新增-->
<!--      </a-button>-->
<!--      <a-button type="primary" :disabled="single" @click="$refs.noticeCreateForm.handleUpdate(undefined, ids)" v-hasPermi="['skoda:circleNotice:edit']">-->
<!--        <a-icon type="edit"/>-->
<!--        修改-->
<!--      </a-button>-->
<!--      <a-button type="danger" :disabled="multiple" @click="handleDelete">-->
<!--        <a-icon type="delete" />删除-->
<!--      </a-button>-->
<!--      <table-setting-->
<!--        :style="{float: 'right'}"-->
<!--        :table-size.sync="tableSize"-->
<!--        v-model="columns"-->
<!--        :refresh-loading="loading"-->
<!--        @refresh="getList"/>-->
    </div>
    <notice-create-form
      ref="noticeCreateForm"
      @ok="getList"
    />
    <!-- table区域-begin        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
    <div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :scroll="{ x: 800}"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" />-->
<!--          <a @click="handleDelete(record)">-->
<!--            <a-icon type="delete"/>删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

    </div>
    <!-- table区域-end -->
  </a-drawer>
  <!-- 表单区域 -->
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import {pageVideoUserLook} from "@/api/shortVideo/video/video";

export default {
  name: 'NoticeForm',
  mixins: [tableMixin],
  components: {  },
  data() {
    return {
      description: '',
      screenWidth: 800,
      formTitle: '观看记录',
      visible: false,
      operateTitle: null,
      operateOpen: false,
      operateType: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      list: [],
      selectedRowKeys: [],
      sendTimeAreaData:[],
      selectedRows: [],
      ids: [],
      model: {},
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      checkParam: {
        id: null,
        status: null,
        reason: null
      },
      form: this.$form.createForm(this),
      loading: false,
      videoId: null,
      total: 0,
      queryParam: {
        nickname: null,
        content: null,
        isTop: null,
        circleId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用戶昵称',
          dataIndex: 'nickname',
          width: '30%',
          align: 'center'
        },
        {
          title: '剧集',
          dataIndex: 'serialNumber',
          width: '20%',
          align: 'center'
        },
        // {
        //   title: '解锁类型',
        //   dataIndex: 'type',
        //   width: '10%',
        //   align: 'center',
        //   customRender: function (t, r, index) {
        //     if(t == 0) {
        //       return '免费'
        //     }else if(t == 1) {
        //       return '必捷斯'
        //     }else if(t == 2) {
        //       return '钻石'
        //     }else if(t == 3) {
        //       return '会員'
        //     }else if(t == 4) {
        //       return '廣告'
        //     }
        //   }
        // },
        // {
        //   title: '必捷斯数/钻石数',
        //   dataIndex: 'price',
        //   width: '10%',
        //   align: 'center'
        // },
        {
          title: '观看时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 200,
          align: 'center'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ],
      startTime:"",
      endTime:""
    }
  },
  filters: {},
  computed: {},
  created() {
  },
  watch: {},
  methods: {
    onChangeTime(e,str) {
      this.queryParam.startTime = str[0];
      this.queryParam.endTime = str[1];
    },
    operateClose() {
      this.operateOpen = false
      this.operateTitle = null
      this.operateType = null
      this.checkParam = {
        id: null,
        status: null,
        reason: null
      }
    },
    checkUser(record) {
      this.checkParam.id = record.id
      this.operateOpen = true
      this.operateTitle = '审核'
      this.operateType = 'check'
    },
    getList() {
      this.loading = true
      this.queryParam.videoId = this.videoId
      pageVideoUserLook(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery(record,startTime,endTime) {
      if (record.id) {
        this.videoId = record.id
      }
      if(startTime || endTime) {
        this.queryParam.startTime = startTime;
        this.queryParam.endTime =endTime;
        this.startTime = startTime;
        this.endTime = startTime;
      } else {
        this.sendTimeAreaData = [];
        this.startTime = "";
        this.endTime = "";
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.visible = true
    },
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        nickname: undefined,
        pageNum: 1,
        pageSize: 10,
        startTime: this.startTime,
        endTime: this.endTime
      }
      // this.sendTimeAreaData = [];
      this.getList()
    },
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({'id': id}))
          return delCircleNotice(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onClose() {
      this.visible = false
      this.form.resetFields()
      this.list = []
    }
  }
}
</script>
